import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcDashboardReducer (state: RootState): AcDashboardState {
  return state.acdashboardReducer
}
